module.exports = __webpack_public_path__ + "static/media/Group 206.12672452.png";